import api from './interceptor';

const BASE_URL_V2 = 'api/v3/globe-med';

export default {
  // API Version 3
  authorizationAppointment: ({ providerId, patientId, appointmentFromTimestamp, authorizationIdentifier }) => api.post(`${BASE_URL_V2}`, { providerId, patientId, appointmentFromTimestamp, authorizationIdentifier }),
  submitAppointment: appointmentId => api.post(`${BASE_URL_V2}/appointment`, { appointmentId }),
  cancelAuthorization: (patientId, cancellationReason) => api.delete(`${BASE_URL_V2}`, { data: { patientId, cancellationReason } }),
};
